var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticStyle:{"display":"block"}},[_c('commheader'),_c('el-main',[_c('div',{staticStyle:{"width":"100%","height":"650px"},attrs:{"id":"chartColumn"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }